import { BidDomainSelectModelSchema } from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { SelectBidOutputSchema } from './select-bid.models.ts'

export const DiscardBidInputSchema = BidDomainSelectModelSchema.pick({
  bidId: true,
})

export type DiscardBidInput = ZodInfer<typeof DiscardBidInputSchema>

export const DiscardBidOutputSchema = SelectBidOutputSchema

export type DiscardBidOutput = ZodInfer<typeof DiscardBidOutputSchema>
